import React from 'react';
import { Link } from 'react-router-dom';
import PublicShell from './PublicShell';

const LegalPage = ({ title, children }) => (
  <PublicShell>
    <article className="legal-page glass-card p-6 md:p-10 max-w-3xl mx-auto">
      <Link to="/" className="text-sm text-white/40 hover:text-white/70 mb-6 inline-block">
        ← Zurück
      </Link>
      <h1 className="section-title text-2xl md:text-3xl mb-6">{title}</h1>
      <div className="legal-prose">{children}</div>
    </article>
  </PublicShell>
);

export default LegalPage;
